import * as Sentry from '@sentry/react';

export type LogContext = { readonly log_source: string } & Readonly<Record<string, unknown>>;

const crumb = (level: 'info' | 'warning', message: string, context: LogContext): void => {
  Sentry.addBreadcrumb({
    level,
    message,
    category: 'logger',
    data: { log_source: context.log_source },
  });
};

export const logger = {
  info: (message: string, context: LogContext): void => {
    crumb('info', message, context);
    if (!import.meta.env.PROD) console.log(message, context);
  },
  error: (message: string, context: LogContext): void => {
    const tags = { log_source: context.log_source };
    const error = context['error'];
    if (error instanceof Error) {
      Sentry.captureException(error, { tags, extra: { ...context, originalMessage: message } });
    } else {
      Sentry.captureMessage(message, { level: 'error', tags, extra: { ...context } });
    }
    if (!import.meta.env.PROD) console.error(message, context);
  },
  warn: (message: string, context: LogContext): void => {
    crumb('warning', message, context);
    if (!import.meta.env.PROD) console.warn(message, context);
  },
};
